/**
 * Class representing a document viewer.
 */
export default class DocViewer {

  /**
   * Generates a table of contents based on the headers found in the document content.
   */
  generateTableOfContents() {
    console.log('DocViewer.generateTableOfContents - Generating table of contents...');
    const toc = document.querySelector('#fe-doc-page-directory-page-items');
    if (!toc) {
      console.error('DocViewer.generateTableOfContents - Table of Contents element not found');
      // Table of Contents element not found
      return;
    }

    const content = document.querySelector('.fe-doc-page-viewer .docContent');
    if (!content) {
      console.error('DocViewer.generateTableOfContents - Content element not found');
      // Content element not found
      return;
    }

    const headers = content.querySelectorAll(
      'h1.docPageSectionHeading, h2.docPageSectionHeading, h3.docPageSectionHeading, ' +
      'h4.docPageSectionHeading, h5.docPageSectionHeading, h6.docPageSectionHeading'
    );
    if (headers.length === 0) {
      console.warn('DocViewer.generateTableOfContents - No headers found in content');
      return;
    }

    const ul = document.createElement('ul');
    ul.classList.add('list-unstyled');
    ul.classList.add('ps-3');
    let currentLevel = parseInt(headers[0].tagName.substring(1));
    let currentUl = ul;
    const ulStack = [ul];

    headers.forEach(header => {
      const level = parseInt(header.tagName.substring(1));
      const anchorLink = header.querySelector('.anchor-link') as HTMLAnchorElement;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = anchorLink ? anchorLink.href : `#${header.id}`;
      a.textContent = header.textContent.trim();
      li.appendChild(a);

      if (level > currentLevel) {
        for (let i = currentLevel; i < level; i++) {
          const newUl = document.createElement('ul');
          newUl.classList.add('list-unstyled');
          newUl.classList.add('ps-3');
          const lastLi = ulStack[ulStack.length - 1].lastElementChild;
          if (lastLi) {
            lastLi.appendChild(newUl);
            ulStack.push(newUl);
          } else {
            console.error('DocViewer.generateTableOfContents - Last list item not found for nesting. Current header:',
              header.textContent.trim(), 'Current ulStack length:', ulStack.length);
            return;
          }
        }
        currentUl = ulStack[ulStack.length - 1];
      } else if (level < currentLevel) {
        ulStack.splice(level - currentLevel);
        currentUl = ulStack[ulStack.length - 1] || ul;
      }

      currentUl.appendChild(li);
      currentLevel = level;
    });

    toc.innerHTML = ul.outerHTML;
  }
}
